export function setUser(state, payload) {
  state.user = payload;
}
export function setRefData(state, payload) {
  state.refData = payload;
}
export function setLoadingArray(state, payload) {
  state.isLoadingArray = payload;
}
